import { AuditLog } from './audit-log.model';

export class AuditLogCollection {
	public logs: AuditLog[];
	public totalItems: number;
}
